<template>
  <spinner v-if="isLoading" text="Loading, please wait..." />

  <v-alert v-if="errorMessageExist" type="error">
    <strong>{{errorMessage}}</strong>
  </v-alert>

  <div v-if="!isLoading && !isError">
    <v-row>
      <v-col>
        <v-form @submit.prevent="update()">
          <div>
            <v-textarea variant="outlined" density="compact" label="Value" v-model="scanValue" rows="3" readonly></v-textarea>
          </div>
          <v-divider class="my-2" />
          <h4>Question & Answers </h4>
          <v-divider class="my-2" />
          <v-row v-for="qa in allQA">
            <v-col md="3">
              <label class="font-weight-bold">{{qa.question}}</label>
            </v-col>
            <v-col md="9">
              <div v-if="qa.type == 'manual' || qa.type == 'barcode'" :class="{'has-error':!qa.answer[0] && qa.is_required == '1'}">
                <div>
                  <v-text-field variant="outlined" density="compact" v-model="qa.answer[0]" :disabled="qa.is_active == 0" :hint="qa.is_active == 0 ? 'This question is currently inactive' : ''" />
                </div>
              </div>

              <div v-if="qa.type == 'manualnumeric' || qa.type == 'barcodenumeric'" :class="{'has-error':!qa.answer[0] && qa.is_required == '1'}">
                <div>{{ typeof qa.answer[qa.question_id] !='undefined' ? qa.answer[qa.question_id][0] : ''}}
                  <v-text-field variant="outlined" density="compact" type="number" pattern="[0-9]+([\.,][0-9]+)?" step="any" v-model="qa.answer[0]" :disabled="qa.is_active == 0" :hint="qa.is_active == 0 ? 'This question is currently inactive' : ''" />
                </div>
              </div>

              <div v-if="qa.type == 'manualmultiline' || qa.type == 'barcodemultiline'" :class="{'has-error':!qa.answer[0] && qa.is_required == '1'}">
                <div>{{ typeof qa.answer[qa.question_id] !='undefined' ? qa.answer[qa.question_id][0] : ''}}
                  <v-textarea variant="outlined" density="compact" v-model="qa.answer[0]"  :disabled="qa.is_active == 0" :hint="qa.is_active == 0 ? 'This question is currently inactive' : ''"></v-textarea>
                </div>
              </div>

              <div v-if="qa.type == 'option'" :class="{'has-error':!answerOption[qa.question_id] && qa.is_required == '1'}" >
                <div v-for="answer in qa.answer ">
                  <div v-if="answer !== ''">
                    <v-radio-group v-model="answerOption[qa.question_id]" density="compact" hide-details>
                      <v-radio :value="answer" :label="$capitalize(answer)" :disabled="qa.is_active === 0" :name="'answerOption_' + qa.question_id" />
                    </v-radio-group>
                  </div>
                </div>
                <div class="text-muted" v-if="qa.is_active == 0">This question is currently inactive</div>
              </div>

              <div v-if="qa.type == 'checkbox'" :class="{'has-error':answerCheckbox[qa.question_id].length == 0 && qa.is_required == '1'}">
                <div>
                  <div v-for="answer in qa.answer">
                    <input type="checkbox" v-if="answer != ''" :checked="typeof allScanAnswers[qa.question_id] !='undefined' && allScanAnswers[qa.question_id].indexOf(answer) > -1"
                           :disabled="qa.is_active == 0" @click="checkAnswer(qa.question_id, answer)" > {{$capitalize(answer)}}
                  </div>
                  <div class="text-muted" v-if="qa.is_active == 0">This question is currently inactive</div>
                </div>
              </div>

              <div v-if="qa.type == 'dropdown'" :class="{'has-error':Object.keys(answerDropdown).length > 0 && answerDropdown[qa.question_id].length == 0 && qa.is_required == '1'}">
                <div>
                  <v-select variant=outlined density="compact" v-model="answerDropdown[qa.question_id]" :items="qa.answer" :disabled="qa.is_active === 0" item-text="text" item-value="value"
                            hide-details :hint="qa.is_active == 0 ? 'This question is currently inactive' : ''" label="Please select" />
                </div>
              </div>

              <div v-if="qa.type == 'webcollect'">
                <div v-if="qa.answer.length > 1">
                  <div v-for="answer in qa.answer">
                    <v-textarea variant="outlined" density="compact" v-model="ansWebcollect[qa.question_id]" disabled />
                  </div>
                </div>
                <div v-if="qa.answer.length <= 1">
                  <div v-for="answer in qa.answer">
                    <v-textarea v-model="ansWebcollect[qa.question_id]" disabled />
                  </div>
                </div>
                <div class="text-muted">Answer protected from edit</div>
              </div>

              <div v-if="allowedQaTypes.indexOf(qa.type) <= -1">
                <div v-if="typeof qa.answerObj[0] !='undefined' && qa.answerObj[0].type == 'geo'">
                  <a :href="'https://maps.google.com?q=' + qa.answerObj[0].text" target="_blank" class="text-black">
                    <small><v-icon icon="mdi-dock-window"></v-icon></small> Click to view
                  </a>
                </div>

                <div v-if="typeof qa.answerObj[0] !='undefined' && (qa.answerObj[0].type == 'dropbox') && qa.answerObj[0].link != ''" >
                  <div>
                    <a :href="qa.answerObj[0].link" target="_blank" >
                      <img :src="qa.answerObj[0].link" class="maxWDropbox img-thumbnail" alt="max dropbox">
                    </a>
                    <br>
                  </div>
                </div>
                <div v-if="typeof qa.answerObj[0] !='undefined' && (qa.answerObj[0].type == 'json') && qa.answerObj[0].link != ''">
                  <div>
                    <a :href="qa.answerObj[0].link" target="_blank" class="text-black">View Image</a>
                  </div>
                </div>

                <div v-if="typeof qa.answerObj[0] !='undefined' && qa.answerObj[0].type == 'base64'">
                  <div>
                    <img :src="qa.answerObj[0].text" class="maxWBase64 img-thumbnail" alt="max Wbase">
                  </div>
                </div>

                <div v-if="typeof qa.answerObj[0] !='undefined' && qa.answerObj[0].type != 'base64' && qa.answerObj[0].type !='dropbox' && qa.answerObj[0].type !='json' && qa.answerObj[0].type !='geo'">
                  <div>
                    <em>{{qa.answer[0] ? qa.answer[0] : "Answer not available" }}</em>
                  </div>
                </div>
                <input type="hidden" v-model="qa.answer[0]">
              </div>
            </v-col>
          </v-row>

          <div v-if="totalCount == 0">
            <div>No questions exists for this scan and the service</div>
          </div>
          <v-row>
            <v-col md="7" class="text-right">
              <v-btn class="text-none" color="black" @click="historyBack();">Cancel</v-btn>
              <v-btn type="submit" color="black" :disabled="isLoading" v-if="totalCount > 0" class="ml-4 text-none">
                <v-progress-circular indeterminate v-if="isLoading" /> Update
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import {ref, onBeforeMount} from "vue";
import {useRoute} from "vue-router";
import ScanModel from "../model/ScanModel"
import messageModel from "../model/MessageModel"
import moment from "moment";

const props = defineProps({
  scanId : {
    type: [Number, String],
    required: true
  },
  userId : {
    type: [Number, String],
    required: false
  },
  token : {
    type: String,
    default: ''
  },
  authentication : {
    type: String,
    default: ''
  },
  onSuccess : {
    type: Function,
  },
  onError : {
    type: Function,
  },
  onCancel : {
    type: Function,
  },
});

const isLoading = ref(true);
const isError = ref(false);
const scan = ref(null);
const scanValue = ref('');
const existScanId = ref(null);
const udid = ref(null);
const serviceId = ref(null);
const totalCount = ref(0);
const errorMessageExist = ref(false);
const errorMessage = ref('');
const allScanAnswers = ref({});
const questionIds = ref([]);
const allQA = ref([]);
const answerCheckB = ref([]);
const allowedQaTypes = ref([
  'option', 'manual', 'manualnumeric', 'manualmultiline', 'checkbox', 'dropdown', 'barcode', 'barcodenumeric', 'barcodemultiline', 'webcollect'
]);
const answerOption = ref({});
const answerCheckbox = ref({});
const answerDropdown = ref({});
const ansWebcollect = ref({});
const scanModel = ref(null);

onBeforeMount(async ()=> {
  scanModel.value = new ScanModel();
  await load();
})

async function load() {
  let scanParams = {
    scan_id: props.scanId,
    user_id: "all",
    deleted_users: "true"
  };

  if (props.authentication != 'api_key') {
    scanParams['token'] = props.token;
  }

  let scanResponse = await scanModel.value.retrieve(scanParams);
  if (scanResponse.status == 1) {
    if (scanResponse.count == 0 ) {
      if (props.onError) {
        props.onError(292);
        isError.value = true;
        isLoading.value = false;
      } else {
        messageModel.getById(292).then((message) => {
          errorMessageExist.value = true;
          errorMessage.value = typeof message !== 'undefined' ? message.text : 'Error without message';
        });
        isLoading.value = false;
      }

      return false;
    }
    scan.value = scanResponse.scan[0];
    scanValue.value = scan.value.tid;
    existScanId.value = scan.value._id;
    for (let scan of scanResponse.scan) {
      serviceId.value = scan.service._id;
      if (typeof scan.answer != 'undefined') {
        for (let ans of scan.answer) {
          if (typeof allScanAnswers.value[ans._qid] == 'undefined'){
            allScanAnswers.value[ans._qid] = [];
          }
          allScanAnswers.value[ans._qid].push(ans.__text);
          questionIds.value.push(ans._qid);
        }

      }
    }
  } else {
    if (props.onError) {
      props.onError(scanResponse.error._code);
      isError.value = true;
      isLoading.value = false;
    } else {
      messageModel.getById(scanResponse.error._code).then((message) => {
        errorMessageExist.value = true;
        errorMessage.value = typeof message !== 'undefined' ? message.text : 'Error without message';;
      });
      isLoading.value = false;
    }

    return false;
  }

  if (scan.value != null) {
    let scananswerResponse = await scanModel.value.retrieveAnswer(scanParams);

    if (scananswerResponse.status == 1) {
      udid.value = scananswerResponse.udid;
      //this.userId = scananswerResponse.user_id;
      allQA.value = scananswerResponse.question;
      totalCount.value = allQA.value.length;

      for (let allqa of allQA.value) {
        allqa['answerObj'] = [];
        if (allqa.type == 'webcollect') {
          if (!Array.isArray(ansWebcollect.value[allqa.question_id])) {
            ansWebcollect.value[allqa.question_id] = [];
          }
        }

        if (allqa.type == 'checkbox') {
          if (!Array.isArray(answerCheckbox.value[allqa.question_id])) {
            answerCheckbox.value[allqa.question_id] = [];
          }
        }

        for (let ans of allqa['answer']) {
          let ansArr = {};
          let text = ans;
          ansArr['text'] = ans;
          ansArr['type'] = '';
          ansArr['link'] = '';
          ansArr['file'] = '';

          if (text != undefined  && text != ' ') {
            if (text.substr(0, 6) == 'geo://') {
              let t = (text.substr(6)).split(',');
              ansArr['text'] = t[0] + ',' + t[1];
              ansArr['type'] = 'geo';
            } else if (text.substr(0, 8) == '<dropbox') {
              text  = text.replace(/\\/g, ' ');
              let existLink = /link=\"([^\s]+)\"/.exec(text);
              let existFile = /file=\"([^\s]+)\"/.exec(text);
              ansArr['type'] = 'dropbox';
              ansArr['link'] = existLink != null ? existLink[1] : '';
              ansArr['file'] = existFile ? existFile[1] : '';
            } else if (text.substr(0, 21) == 'data:image/png;base64') {
              ansArr['text'] = text.replace(/\\/g, '');
              ansArr['type'] = 'base64';
            } else if (text.indexOf('{') == 0) {
              try {
                let jsonAns = JSON.parse(text);
                ansArr['type'] = 'json';
                ansArr['link'] = jsonAns.link;
                ansArr['file'] = jsonAns.filename;
              } catch (e) {
              }
            }
          } else {
            ansArr['text'] = '';
          }


          allqa['answerObj'].push(ansArr);

          if (typeof allScanAnswers.value[allqa.question_id] !== 'undefined' && allScanAnswers.value[allqa.question_id].includes(ans)) {
            if (allqa.type == 'checkbox') {
              if (!Array.isArray(answerCheckbox.value[allqa.question_id])) {
                answerCheckbox.value[allqa.question_id] = [];
              }
              if (ans != '') {
                answerCheckbox.value[allqa.question_id].push(ans);
              }
            }

            if (allqa.type == 'option') {
              if (ans != '') {
                answerOption.value[allqa.question_id] = ans;
              }
            }
            if (allqa.type == 'dropdown') {
              answerDropdown.value[allqa.question_id] = ans ;
            }
            if (allqa.type == 'webcollect') {
              ansWebcollect.value[allqa.question_id].push(ans) ;
            }
          }

          if (allqa.type == 'barcodenumeric' || allqa.type == 'manualnumeric') {
            allqa['answer'][0] = ans;
          }
        }
      }
    } else {
      if (props.onError) {
        isError.value = true;
        props.onError(scananswerResponse.error._code);
      } else {
        messageModel.getById(scananswerResponse.error._code).then((message) =>{
          errorMessageExist.value = true;
          errorMessage.value = typeof message !== 'undefined' ? message.text : 'Error without message';
        });

      }
      isLoading.value = false;
      return false;
    }
  }
  isLoading.value = false;
}

function historyBack() {
  if (props.onCancel) {
    props.onCancel();
  } else {
    window.history.back();
  }
}

function checkAnswer(questionId, answer) {
  if (!Array.isArray(answerCheckbox.value[questionId])) {
    answerCheckbox.value[questionId] = [];
  }
  if(answerCheckbox.value[questionId].indexOf(answer) > -1) {

    let answers = [];
    for (let a of answerCheckbox.value[questionId]) {
      if (a != answer) {
        answers.push(a);
      }
    }
    answerCheckbox.value[questionId] = answers;
  } else {
    answerCheckbox.value[questionId].push(answer);
  }
}

async function update() {
  isLoading.value = true;

  let answerForUpdate = {};
  let isAnswerError = false;

  for (let question of allQA.value) {
    let key = question.question_id;
    key = key.toString();

    if (question.answer != undefined) {
      if (question.type == 'checkbox') {
        if (answerCheckbox.value[question.question_id].length == 0 && question.is_required == '1') {
          isAnswerError = true;
        }
        if (answerCheckbox.value[question.question_id].length > 0) {
          answerForUpdate[key] = answerCheckbox.value[question.question_id].join('|^|');
        }
      } else if (question.type == 'option') {
        if (answerOption.value[question.question_id] == '' && question.is_required == '1') {
          isAnswerError = true;
        }
        if (answerOption.value[question.question_id] != '') {
          answerForUpdate[key] = answerOption.value[question.question_id];
        }
      } else if (question.type == 'dropdown') {
        if (answerDropdown.value[question.question_id] == '' && question.is_required == '1') {
          isAnswerError = true;
        }
        if (answerDropdown.value[question.question_id] != '') {
          answerForUpdate[key] = answerDropdown.value[question.question_id];
        }
      } else if (question.type == 'webcollect') {
        answerForUpdate[key] = ansWebcollect.value[question.question_id].join('|^|');
      } else {

        if ((typeof question.answer == 'undefined' || question.answer[0] == null || question.answer[0] == '') && question.is_required == '1') {
          isAnswerError = true;
        }
        if (typeof question.answer != 'undefined') {
          answerForUpdate[key] = question.answer[0];
        }
      }
    }
  }

  if (isAnswerError) {
    if (props.onError) {
      props.onError(2548);
    } else {
      messageModel.getById(2548).then((message) => {
        errorMessageExist.value = true;
        errorMessage.value = typeof message !== 'undefined' ? message.text : 'Error without message';;
      });

    }
    isLoading.value = false;
  } else {
    let currentDate = moment().format('YYYY-MM-DD HH:mm:ss');

    let ssparams = {
      token: props.token,
      scanid: parseInt(String(props.scanId)),
      sid: serviceId.value,
      udid: udid.value,
      userid: props.userId,
      scan_updated: currentDate,
      manual_update: 1
    };
    if (props.authentication != 'api_key') {
      ssparams.token = props.token;
    }
    answerForUpdate = JSON.stringify(answerForUpdate);
    let secureScanResponse = await scanModel.value.securescan(ssparams, answerForUpdate);
    if (secureScanResponse.message.status == 1 || secureScanResponse.message.status == -1) {
      if (props.onSuccess) {
        props.onSuccess(2487);
      }
      isLoading.value = false;
    } else {
      if (props.onSuccess) {
        props.onSuccess(secureScanResponse.message.text);
      }
      isLoading.value = false;
    }
  }
}
</script>

<style scoped lang="scss">

</style>